
<div v-if="hasCoupons" class="discountBanner" :class="{compact, heightAdaptive, fullOnMobile, rounded: !tile, 'rounded-0': tile}">
  <div ref="progress" :class="{discountProgress: true, active: isOpen}"
       role="button"
       tabindex="0"
       :aria-expanded="isOpen ? 'true' : 'false'"
       :aria-label="$t('COUPON_TITLE')"
       :aria-haspopup="mobile ? 'dialog' : undefined"
       @click="toggleOpen()"
       @keydown.enter.prevent="open = !open"
       @keydown.space.prevent="open = !open"
       @keydown.esc.prevent="close()"
       @focusout="onFocusOut()"
       @mouseover="onHover(true)"
       @mouseleave="onHover(false)"
  >
    <div class="bannerHeader">
      <span class="stage"><span class="stageIcon secondary" aria-hidden="true">%</span>{{ $t('COUPON_STAGE').replace('{current}', nextCouponIndex).replace('{total}', discountCoupons.length) }}</span>
      <span v-if="activeCoupon" class="activeReward rewardStatus">
        <v-icon size="16" class="rewardCheck">check</v-icon>
        {{ $t('COUPON_REWARD_ACTIVE').replace('{reward}', rewardLabel(activeCoupon)) }}
      </span>
    </div>
    <div class="progressTrack">
      <span class="discount" :style="{left: `${discountPercentage}%`}" aria-hidden="true" v-html="discountSvg"></span>
      <div class="meter">
        <span class="secondary progress" :style="{width: `${discountPercentage}%`}"></span>
        <span v-for="(coupon, index) in discountCoupons" :key="index" v-if="coupon.minimumValue > 0 && coupon.minimumValue < maxGoal"
              class="marker" :style="{'left': `${percentageOf(coupon.minimumValue)}%`}"></span>
        <div v-if="!mobile && !detachedDetails" class="secondary tooltip" v-show="isOpen">
          <DiscountDetails :coupons="coupons" :subtotal="subtotal" :next-coupon="nextCoupon" :expiry-date="expiryDate"/>
        </div>
      </div>
    </div>
    <div class="bannerSummary" :class="{centeredOnMobile: !activeCoupon}">
      <span v-if="(!mobile || fullOnMobile) && freeShippingCoupon && (hasNextCoupon || !hasPendingShippingReward)" class="freeShipping" :class="{rewardStatus: couponActive(freeShippingCoupon)}">
        <template v-if="couponActive(freeShippingCoupon)">
          <v-icon size="16" class="rewardCheck">check</v-icon>
          {{ $t('COUPON_REWARD_SHIPPING') }}
        </template>
        <template v-else>
          {{ $t('COUPON_SHIPPING_FROM').replace('{value}', formatPrice(freeShippingCoupon.minimumValue)) }}
        </template>
      </span>
      <i18n v-if="nextRewardCoupon" path="COUPON_NEXT_REWARD" tag="p" class="missing">
        <strong place="value" class="missingValue">{{ formatPrice(nextRewardCoupon.minimumValue - subtotal) }}</strong>
        <strong place="reward" class="nextReward">{{ rewardLabel(nextRewardCoupon) }}</strong>
      </i18n>
      <p v-else class="missing allActivated">
        {{ $t('COUPON_ALL_ACTIVATED') }}
      </p>
    </div>
  </div>
  <v-menu v-if="!mobile && detachedDetails" v-model="open" :activator="desktopActivator"
          open-on-hover :open-on-click="false" :close-on-content-click="false" :close-delay="150"
          offset-y :nudge-right="desktopPopoverOffset" max-width="350" max-height="calc(100vh - 32px)" content-class="discountDetailsPopover">
    <DiscountDetails :coupons="coupons" :subtotal="subtotal" :next-coupon="nextCoupon" :expiry-date="expiryDate"/>
  </v-menu>
  <v-dialog v-if="mobile" v-model="open" max-width="350" content-class="discountDetailsDialog"
            :aria-label="$t('COUPON_TITLE')">
    <DiscountDetails :coupons="coupons" :subtotal="subtotal" :next-coupon="nextCoupon"
                     :expiry-date="expiryDate" modal @close="close()"/>
  </v-dialog>
</div>

